import { CSSProperties } from 'react';

type InfoIconProps = {
  width?: string;
  style?: CSSProperties;
};

export const InfoIconNew = ({ width, ...props }: InfoIconProps): JSX.Element => (
  <svg
    width={width || '14'}
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z" fill="#00B9CE" />
    <path d="M7.375 2.625C7.87784 2.625 8.28409 3.06698 8.28409 3.61405C8.28409 4.16112 7.87784 4.6031 7.375 4.6031C6.87216 4.6031 6.46591 4.16112 6.46591 3.61405C6.46591 3.06698 6.87216 2.625 7.375 2.625ZM8.625 11.375H6.125V11.035H6.75V6.08977H6.125V5.71887H8V11.035H8.625V11.375Z" fill="white" />
  </svg>
);
